<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Appointment Days</h1>
          </div>
          <div class="col-sm-2">

            <router-link v-if="hasPermission('appointment-day create')" style="margin-right: 10px"
              class="btn btn-primary" :to="{ name: 'create-appointmentDay' }">create</router-link>
            <router-link v-if="hasPermission('appointment-day getSoftDeleted')" class="btn btn-success"
              :to="{ name: 'deleted-appointmentDays' }">Deleted
              Appointments</router-link>
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <h5 class="over-title margin-bottom-15">
              <!-- Basic <span class="text-bold">Data Table</span> -->
            </h5>
            <p>

            </p>
            <div v-if="appointmentDays.length > 0">

              <MyTable :columns="columns" :actions="true">
                <tr v-for="(appointmentDay, index) in appointmentDays" :key="index">
                  <th scope="row">{{ appointmentDay.id }}</th>
                  <td>{{ appointmentDay.name_ar }}</td>
                  <td>{{ appointmentDay.name_en }}</td>
                  <td>{{ appointmentDay.available }}</td>
                  <td>
                    <button v-if="hasPermission('appointment-day delete')" class="me-2 btn btn-danger"
                      @click="deleteAppointmentDay(appointmentDay.id)">
                      Delete
                    </button>
                    <router-link v-if="hasPermission('appointment-day update')" class="btn btn-primary spacing"
                      :to="{ name: 'edit-appointmentDay', params: { id: appointmentDay.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No appointments found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>
<script>
import axios from "../../Axios";
import { store } from "../../Store";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
export default {
  name: "AllAppointmentDays",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [], // Store DataTable instance
      appointmentDays: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        { label: 'Available', key: 'available' },
      ],
    };
  },

  async created() {
    this.fetchAppointmentDays();
  },
  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
  },
  // computed: {
  //   filteredAppointmentDays() {
  //     if (!this.searchTerm) {
  //       return this.appointmentDays;
  //     }
  //     const term = this.searchTerm.toLowerCase();
  //     return this.appointmentDays.filter(
  //       (appointmentDay) =>
  //         appointmentDay.name.toLowerCase().includes(term) ||
  //         appointmentDay.postal_code.toLowerCase().includes(term)
  //     );
  //   },
  // },

  methods: {
    // fetch orders
    async fetchAppointmentDays() {
      try {
        const response = await axios.get(
          `/admin/admin/appointment-day/all`
        );
        this.appointmentDays = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
        console.log('response', response.data.data)
      } catch (error) {
        console.error("Error fetching days:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteAppointmentDay(id) {
      console.log("delete day id: ", id);
      axios
        .delete(`/admin/admin/appointment-day/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchAppointmentDays();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>
